export default __webpack_public_path__ + "static/media/ClutchImg.f4def096.png";